import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formattedNumber'
})
export class FormattedNumberPipe implements PipeTransform {
  transform(value: number | string): string {
    if (typeof value === 'number') {
      if (value > 0) {
        return value.toLocaleString('en-US');
      } else if (value < 0) {
        const absoluteValue = Math.abs(value);
        const formatted = absoluteValue.toLocaleString('en-US');
        return `(${formatted})`;
      } else {
        return '-';
      }
    }
    return value as string;
  }
}
